'use client'
import {
  useConfig_default
} from "./chunk-UDUUTZIS.mjs";
import {
  __spreadValues
} from "./chunk-BBBOZKTU.mjs";

// src/components/Link.tsx
import { jsx } from "react/jsx-runtime";
var Link = (props) => {
  const { router } = useConfig_default();
  return /* @__PURE__ */ jsx(router.Link, __spreadValues({}, props));
};
var Link_default = Link;

// src/components/Trans.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var Trans = (props) => {
  const { i18n } = useConfig_default();
  return /* @__PURE__ */ jsx2(i18n.Trans, __spreadValues({}, props));
};
var Trans_default = Trans;

export {
  Link_default,
  Trans_default
};
//# sourceMappingURL=chunk-EKKAL3IG.mjs.map